module.exports = __webpack_public_path__ + "img/info.7ba6dc07.svg";